import { clubbiStyled, Modal, CloseIcon } from 'clubbi-ui'
interface ContainerProps {
  showWidget: boolean
  showSuccess?: boolean
}
export const StyledModal = clubbiStyled(Modal)<ContainerProps>(({ theme, showWidget }) => ({
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  outlineColor: theme.palette.brandWhite.main,

  ...(!showWidget && {
    marginTop: '40px',
    [theme.breakpoints.up('sm')]: {
      marginTop: '200px',
    },
  }),
}))

export const StyledContainer = clubbiStyled('div')<ContainerProps>(({ theme, showWidget }) => ({
  width: '100vw',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  height: '100vh',
  overflowY: 'auto',
  position: 'absolute',
  borderRadius: '8px',
  background: theme.palette.brandWhite.main,

  ...(!showWidget && {
    width: '350px',
    height: '281px',
    padding: '0',

    [theme.breakpoints.up('sm')]: {
      top: '100px',
    },
  }),

  ...(showWidget && {
    width: '100vw',
    height: '100vh',
    padding: '22px 26px',

    [theme.breakpoints.up('sm')]: {
      width: '600px',
      height: '500px',
      top: '15vh',
    },
  }),
}))

export const StyledCloseButton = clubbiStyled('button')(({ theme }) => ({
  textDecoration: 'underline',
  border: 'none',
  position: 'absolute',
  right: '20px',
  top: '20px',

  backgroundColor: theme.palette.brandWhite.main,
}))

export const StyledCloseIcon = clubbiStyled(CloseIcon)(() => ({
  width: '20px',
}))

export const StyledContainerInput = clubbiStyled('p')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'start',
  gap: '2px',
  margin: '18px 0',
  position: 'relative',

  color: theme.palette.brandAlert.main,
}))

export const StyledInput = clubbiStyled('input')<{ invalid: boolean }>(({ theme, invalid }) => ({
  fontSize: theme.typography.fontSize3XL,
  lineHeight: '38px',
  textTransform: 'uppercase',
  letterSpacing: '2px',
  width: '160px',
  height: '56px',
  outline: 'none',
  padding: '0 10px',
  borderRadius: '4px',
  border: `1px solid ${invalid ? theme.palette.brandAlert.main : theme.palette.brandPurple[60]}`,
  boxShadow: invalid ? `1px 1px 3px ${theme.palette.brandAlert[30]}` : 'none',

  color: theme.palette.brandGrey[100],
}))

export const StyledErrorMessage = clubbiStyled('p')(({ theme }) => ({
  fontSize: theme.typography.fontSize2XS,

  color: theme.palette.brandAlert.main,
}))
